import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const LinkSectionGroup = _ref => {
  let {
    title,
    children
  } = _ref;
  return /*#__PURE__*/_jsxs("li", {
    className: "main-footer__links-section-item",
    children: [/*#__PURE__*/_jsx("div", {
      className: "main-footer__links-section-label",
      children: title
    }), /*#__PURE__*/_jsx("ul", {
      className: "main-footer__links-section-group",
      children: children
    })]
  });
};

export default LinkSectionGroup;